import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PagamentoDespesaInserirComponent } from './pagamento-despesa-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: PagamentoDespesaInserirComponent }
    ])],
    exports: [RouterModule]
})
export class PagamentoDespesaInserirRoutingModule { }
